import { render } from "./Label.vue?vue&type=template&id=37a4b5d8&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=37a4b5d8&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a4b5d8"]])

export default __exports__